import React from 'react';
import EArchiveGroupToolbar from './EArchiveGroupToolbar';
import { useSelectUsersContext } from '../../Services/SelectUsersContext';
import { useGroupsContext } from '../../Services/GroupsContext';
import { GroupDetailListContent } from '../../Enums/GroupDetailListContent.enum';
import { useCreateGroupMembersMutation } from '../../../../graphql/graphql';
import useNotification from '../../../../Hooks/useNotification.hook';
import useApiClient from '../../../Base/Hooks/useApiClient';

interface Props {
	groupId?: string;
}

const EArchiveAddMembersToGroupToolbar = ({ groupId }: Props) => {
	const { userIds, stopSelectingUsers } = useSelectUsersContext();
	const { setGroupDetailListContent } = useGroupsContext();
	const [createGroupMembers] = useCreateGroupMembersMutation();
	const { showNotificationSuccess, showNotificationAlert } = useNotification();
	const { displayGQLError } = useApiClient();

	const onCancel = () => {
		stopSelectingUsers();
		setGroupDetailListContent(GroupDetailListContent.MEMBERS);
	};

	const onSubmit = async () => {
		try {
			if (!(groupId && userIds.length)) {
				return showNotificationAlert({
					content: 'component.eArchive.group.members.atLeastOneMember',
				});
			}

			const response = await createGroupMembers({
				input: { groupId, userIds },
			});

			if ('data' in response) {
				showNotificationSuccess({
					content: 'component.eArchive.group.members.addMembersSuccess',
				});
				onCancel();
			} else {
				displayGQLError(response);
			}
		} catch (error) {
			showNotificationAlert({ content: 'base.shared.warningBug' });
		}
	};

	return (
		<EArchiveGroupToolbar
			onSubmit={onSubmit}
			onCancel={onCancel}
			submitText={'base.shared.form.send'}
			cancelText={'base.shared.cancel'}
		/>
	);
};

export default EArchiveAddMembersToGroupToolbar;
